import React from 'react';

import { Page } from '../../components/layouts';
import { LoginDialog } from '../../components/partials';
import { RouteParams } from '../../core/types/route.types';
import {
  DispatchProps,
  StateProps,
} from '../../weborder/component/PhoneNumber';

type Props = StateProps & DispatchProps & RouteParams;

export function Login(props: Props): JSX.Element {
  const {
    actions,
    appConfig,
    enableRememberMe,
    languageCode,
    LastRestaurantUrl: lastRestaurantUrl,
    loginErrorMessage,
    loginStartPoint,
    params,
    PhoneNumberConfig: phoneNumberConfig,
    rememberMe,
    translate,
  } = props;

  return (
    <Page pageName="login-dialog">
      <LoginDialog
        actions={actions}
        configData={appConfig}
        enableRememberMe={enableRememberMe}
        loginErrorMessage={loginErrorMessage}
        languageCode={languageCode}
        lastRestaurantUrl={lastRestaurantUrl}
        loginStartPoint={loginStartPoint}
        params={params}
        phoneNumberConfig={phoneNumberConfig}
        rememberMe={rememberMe}
        translate={translate}
      />
    </Page>
  );
}
